module.exports = {"notFound":"Nenájdený","exists":"Existujúci","duplicated":"Duplicitný"}